import React, { useState, useContext, useEffect, } from 'react';
import { Form, Typography, Input, Alert, Space, Row, Button, Flex } from 'antd';
import { EditOutlined, SaveOutlined, WarningFilled, CloseCircleFilled } from '@ant-design/icons';
import { Modal } from '../../UI/Modal/Modal.component';
import { StationPermissionsContext } from '../../../pages/Dashboard/StationScreen';
import { StationContext } from '../../../context/station-context';
import { updateSerialNumber } from '../../../services/StationService';
import { DeviceRestrictedInput } from '../Station/Devices/DeviceRestrictedInput.component';
import { useNotificationApi } from '../../UI/NotificationProvider';

const { Text, } = Typography;

const layout = {
    labelCol: {
        span: 12,
    },
    wrapperCol: {
        span: 12,
    },
};

export const EditSerialNumberModal = ({deviceType, serialNum, location, id, displayField, ...props}) => {

    const notificationApi = useNotificationApi();

    const userPermissions = useContext(StationPermissionsContext);
    const { edit: allowEdit } = userPermissions.station;

    const [state, dispatch] = useContext(StationContext);
    const [ displayModal, setDisplayModal ] = useState(false);
    const [ form ] = Form.useForm();
    const [ errorMessage, setErrorMessage ] = useState('');
    
    const displayAlertMessage = (response) => {

        let errorMessage; 

        switch(response.message){
            case 'duplicate':
                errorMessage = `Serial number already exists!`;
                break;
            default: 
                errorMessage = response.message;
                break;
        }

        return errorMessage;
    }

    const onFinish = (data) => {

        Object.assign(data, {id: id});

        updateSerialNumber(data).then( function (response) {
            if ( !response.result && response.message) {
                setErrorMessage(displayAlertMessage(response));
                return;
            } else {
                notificationApi.success({
                    message: 'Success!',
                    description: `Serial Number has been successfully updated.`,
                });
                dispatch({
                    type: 'UPDATE_SERIAL_NUMBER', 
                    payload: data,
                })
                props.setVisible ? props.setVisible(false) : setDisplayModal(false);
                
                if(props.setEditDeviceDrawer){
                    props.setEditDeviceDrawer(false);
                }
            }
        })
    }

    return (
        <>
            {displayField && allowEdit ? 
                <div onClick={() => setDisplayModal(true)}>
                    <Input 
                        value={serialNum} 
                        suffix={<EditOutlined onClick={() => setDisplayModal(true)} />}
                    />
                </div>
                : null
            } 

            <Modal 
                key={`${serialNum}`}
                icon={<WarningFilled/>}
                color="var(--error-color)"
                title="Edit Serial Number"
                justifyTitle="middle"
                visible={props.visible || displayModal}
                setVisible={props.setVisible || setDisplayModal}
                actionBtnProps={{size: 'default'}}
                width={'60ch'}
                id='modal__edit-serial-number'
            >
                <>
                    <Alert
                        message=''
                        description={
                            <>
                                <Text type='danger'>Changing the Serial Number may break the functionality of your AvaLAN device. Please use this only if you have replaced the current AvaLAN device.</Text>
                            </>
                        }
                        type='error'
                        closable={false}
                        style={{textAlign: 'center', marginBottom: 15 }}
                        showIcon={false}
                    />
                    <Form
                        {...layout}
                        form={form}
                        name={`edit-serial-number-${serialNum}`}
                        labelAlign='left'
                        autoComplete='off'
                        style={{ margin: 0 }}
                        onFinish={ (values) => onFinish(values)}
                        initialValues={{ deviceType: deviceType, serialNum: serialNum, newSerialNum: ''}}
                        preserve={false}
                        size='default'
                        onFieldsChange={() => {setErrorMessage(false)}}
                        >
                        <DeviceRestrictedInput
                            label='Device Type:'
                            name='deviceType'
                            >
                            <Input.TextArea autoSize disabled style={{textAlign: 'center', height: '100%'}}/>
                        </DeviceRestrictedInput>
                        <DeviceRestrictedInput
                            label='Device Serial Number:'
                            name='serialNum'
                            >
                            <Input disabled style={{textAlign: 'center'}}/>
                        </DeviceRestrictedInput>
                        <DeviceRestrictedInput
                            label='New Serial Number:'
                            name='newSerialNum'
                            hasFeedback
                            onChange={(e) => 
                                form.setFieldsValue({
                                newSerialNum: e.target.value.toUpperCase(),
                            })}
                            rules={[
                                {
                                    required: true,
                                    message: 'New serial number is required'
                                }
                            ]}
                            >
                            <Input style={{textAlign: 'center'}}/>
                        </DeviceRestrictedInput>
                        { errorMessage &&
                            <Row justify='center'>
                                <Space>
                                    <CloseCircleFilled style={{color: 'var(--error-color)'}} />
                                    <Text type='danger'>{errorMessage}</Text>
                                </Space>
                            </Row>
                        }
                        <Flex gap='small' align='end' justify='end'>
                            <Button onClick={() => props.setVisible ? props.setVisible(false) : setDisplayModal(false)}>Cancel</Button>
                            <Form.Item noStyle>
                                <Button htmlType='submit' type='primary' danger icon={<SaveOutlined/>}>Save Changes</Button>
                            </Form.Item>
                        </Flex>
                    </Form>
                </>
            </Modal>
        </>
    )
}

EditSerialNumberModal.defaultProps = {
    displayField: true,
    id: 0,
}